<template>
  <div class="row">
    <div class="col s12">
      <form @submit.prevent="handleNext">
        <div class="section">
          <div class="card z-depth-0 grey lighten-4">
            <div class="card-content">
              <span class="card-title teal-text"><span class="chip">4/6</span> Status<i class="material-icons right"
                  v-if="
                    selectedDurationMonth &&
                    selectedDurationYear &&
                    selectedInvoice
                  ">check_circle</i></span>
            </div>

            <div class="card-panel teal-text">
              <div class="row">
                <div class="col s12">
                  <span class="black-text">Scheme Start Date</span>
                </div>
              </div>
              <div class="row">
                <div class="col s12 m7">
                  <div class="input-field">
                    <FilterSimpleDiv inputId="filterDurationMonth" fieldName="Select Month"
                      :data="filterDurationMonthData" :placeHolder="returnMonth" :search="false"
                      browserAutocomplete="off" @selected="handlePick" />
                  </div>
                </div>
                <div class="col s12 m5">
                  <div class="input-field">
                    <FilterSimpleDiv inputId="filterDurationYear" fieldName="Select Year" :data="filterDurationYearData"
                      :search="false" :placeHolder="returnYear" browserAutocomplete="off" @selected="handlePick" />
                  </div>
                </div>
              </div>
            </div>

            <div class="card-panel teal-text">
              <div class="row">
                <div class="col s12">
                  <span class="black-text">Invoicing Cycle</span>
                </div>
              </div>
              <div class="row">
                <div class="col s12">
                  <div class="input-field">
                    <FilterSimpleDiv inputId="filterInvoice" fieldName="Select Cycle" :data="filterInvoiceData"
                      :search="false" :placeHolder="returnInvoice" browserAutocomplete="off" @selected="handlePick" />
                  </div>
                </div>
              </div>
            </div>

            <div class="status-action-row">
              <a href="#" class="waves-effect waves-light btn-large black" @click.prevent="handleBack()">
                <i class="material-icons left">chevron_left</i> Back
              </a>

              <button class="waves-effect waves-light btn-large blue" :class="{
                disabled:
                  isSubmitting ||
                  !selectedDurationMonth ||
                  !selectedDurationYear ||
                  !selectedInvoice,
              }">
                <i class="material-icons left">chevron_right</i>{{ isSubmitting ? "Loading..." : "Next" }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, watchEffect } from "vue";
// import postItem from "@/composables/postItem";
import FilterSimpleDiv from "@/components/search/FilterSimpleDiv.vue";

export default {
  name: "StatusOnboardComponent",
  components: { FilterSimpleDiv },
  emits: ["back", "next"],
  props: ["cat", "newClient"],
  setup(props, context) {
    const isSubmitting = ref(false);
    const error = ref(null);
    const responseDurationYearDefault = ref(null);
    const responseDurationMonthDefault = ref(null);
    const responseInvoiceDefault = ref(null);
    const selectedItem = ref(null);
    const returnYear = ref(null);
    const selectedDurationYear = ref(null);
    const returnMonth = ref(null);
    const selectedDurationMonth = ref(null);
    const returnInvoice = ref(null);
    const selectedInvoice = ref(null);

    // check for back
    onMounted(() => {
      if (props?.newClient?.status) {
        // reload Invoice cycle
        let cycle = getCycle();
        // current obj
        const invoiceCycle = cycle.find(x => x.timing == props?.newClient?.status?.[1]?.value);
        // set
        selectedInvoice.value = { name: invoiceCycle?.period, timing: invoiceCycle?.timing };
        // placehold
        returnInvoice.value = invoiceCycle?.period;


        // reload month
        let month = getMonths();
        // get month
        const monthFromStartDate = props?.newClient?.status?.[0]?.value?.substring(4, 6); // "09"
        // current obj
        const startMonth = month.find(x => x.month == monthFromStartDate);
        // set
        selectedDurationMonth.value = { name: startMonth.period, search: startMonth.month };
        // placehold
        returnMonth.value = startMonth?.period;


        // reload year
        let year = getYears();
        // get year
        const yearFromStartDate = props?.newClient?.status?.[0]?.value?.substring(0, 4);  // "2025"
        // current obj
        const startYear = year.find(x => x.year == yearFromStartDate);
        // set
        selectedDurationYear.value = { name: startYear.period, search: startYear.year };
        // set placehold
        returnYear.value = startYear?.period;

      }
    });

    // Duration (Month)
    const filterDurationMonthData = computed(() => {
      // start
      let val = null;

      let valPlus;

      if (responseDurationMonthDefault.value) {
        if (responseDurationMonthDefault.value.key == "filterDurationMonth") {
          valPlus = responseDurationMonthDefault.value.value.reduce(
            (newArr, x) => {
              newArr[x.period] = null;
              return newArr;
            },
            {}
          );
          val = { ...val, ...valPlus };
        }
      }

      // return final
      return val;
    });

    // Duration (Year)
    const filterDurationYearData = computed(() => {
      // start
      let val = null;

      let valPlus;

      if (responseDurationYearDefault.value) {
        if (responseDurationYearDefault.value.key == "filterDurationYear") {
          valPlus = responseDurationYearDefault.value.value.reduce(
            (newArr, x) => {
              newArr[x.period] = null;
              return newArr;
            },
            {}
          );
          val = { ...val, ...valPlus };
        }
      }

      // return final
      return val;
    });

    // Duration (Month)
    const filterInvoiceData = computed(() => {
      // start
      let val = null;

      let valPlus;

      if (responseInvoiceDefault.value) {
        if (responseInvoiceDefault.value.key == "filterInvoice") {
          valPlus = responseInvoiceDefault.value.value.reduce((newArr, x) => {
            newArr[x.period] = null;
            return newArr;
          }, {});
          val = { ...val, ...valPlus };
        }
      }

      // return final
      return val;
    });

    const getMonths = () => {
      // load
      let val = [
        { period: "January", month: '01' },
        { period: "February", month: '02' },
        { period: "March", month: '03' },
        { period: "April", month: '04' },
        { period: "May", month: '05' },
        { period: "June", month: '06' },
        { period: "July", month: '07' },
        { period: "August", month: '08' },
        { period: "September", month: '09' },
        { period: "October", month: '10' },
        { period: "November", month: '11' },
        { period: "December", month: '12' },
      ];
      // return
      return val;
    }

    const getYears = () => {
      // load
      let currentYear = new Date().getFullYear();

      let val = [
        {
          period: `${(currentYear - 1).toString()}`,
          year: currentYear - 1,
        },
        { period: currentYear.toString(), year: currentYear },
        {
          period: `${(currentYear + 1).toString()}`,
          year: currentYear + 1,
        },
      ];
      // return
      return val;
    }

    const getCycle = () => {
      // load
      let val = [
        { period: "Yearly", timing: 12 },
        { period: "Every 6 Months", timing: 6 },
        { period: "Every 3 Months", timing: 3 },
        { period: "Every 2 Months", timing: 2 },
        { period: "Monthly", timing: 1 },
      ];
      // return
      return val;
    }

    // filter (Initialize)
    onMounted(() => {
      // initialize filterDuration
      // get months
      let val = getMonths();

      // set
      responseDurationMonthDefault.value = {
        key: "filterDurationMonth",
        value: val,
      };
    });


    // filter (Initialize)
    onMounted(() => {
      // initialize filterDuration
      // get years
      let val = getYears();

      // set
      responseDurationYearDefault.value = {
        key: "filterDurationYear",
        value: val,
      };
    });

    // filter (Initialize)
    onMounted(() => {
      // initialize filterDuration
      // get invoice cycle
      let val = getCycle();

      // set
      responseInvoiceDefault.value = {
        key: "filterInvoice",
        value: val,
      };
    });

    // handle back
    const handleBack = () => {
      // emit new parameters
      context.emit("back", {
        id: "status",
        value: true,
      });
    }

    // handle next
    const handleNext = async () => {
      if (
        !selectedDurationMonth.value ||
        !selectedDurationYear.value ||
        !selectedInvoice.value
      ) {
        error.value = "All fields not selected"; // most unlikely
      } else {
        // start
        isSubmitting.value = true;
        error.value = false;

        // set timeformat
        let timeformat = `${selectedDurationYear.value.search}${selectedDurationMonth.value.search}01`;

        // round up
        const newVal = [
          {
            setting: "policyDate",
            value: timeformat,
            scope: null, // props.newClient.id
          },
          {
            setting: "premiumCycle",
            value: selectedInvoice.value.timing,
            scope: null, // props.newClient.id
          },
        ];

        // emit new parameters
        context.emit("next", {
          id: "status",
          value: newVal,
        });

        // // post item
        // const { res, err } = await postItem("rules", newVal);

        // if (res.value) {
        //   // next
        //   // emit new parameters
        //   context.emit("next", {
        //     id: "status",
        //     value: true,
        //   });
        // } else {
        //   error.value = err.value;
        // }
      }
    };

    // get option
    const handlePick = (val) => {
      selectedItem.value = val;
      // watchEffect will take over from here
    };

    // search watcher
    watchEffect(() => {
      // start
      if (selectedItem.value) {
        // sort
        if (selectedItem.value.id == "filterDurationMonth") {
          //set
          if (!selectedItem.value.value) {
            selectedDurationMonth.value = null;
          } else {
            responseDurationMonthDefault.value.value.forEach((x) => {
              if (x.period == selectedItem.value.value) {
                // found
                selectedDurationMonth.value = {
                  name: x.period,
                  search: x.month,
                };
              }
            });
          }
        } else if (selectedItem.value.id == "filterDurationYear") {
          //set
          if (!selectedItem.value.value) {
            selectedDurationYear.value = null;
          } else {
            responseDurationYearDefault.value.value.forEach((x) => {
              if (x.period == selectedItem.value.value) {
                // found
                selectedDurationYear.value = { name: x.period, search: x.year };
              }
            });
          }
        } else if (selectedItem.value.id == "filterInvoice") {
          //set
          if (!selectedItem.value.value) {
            selectedInvoice.value = null;
          } else {
            responseInvoiceDefault.value.value.forEach((x) => {
              if (x.period == selectedItem.value.value) {
                // found
                selectedInvoice.value = { name: x.period, timing: x.timing };
              }
            });
          }
        }
      }
    });

    return {
      isSubmitting,
      error,
      handleNext,
      handleBack,
      handlePick,
      filterDurationMonthData,
      filterDurationYearData,
      filterInvoiceData,
      returnMonth,
      selectedDurationMonth,
      returnYear,
      selectedDurationYear,
      returnInvoice,
      selectedInvoice,
    };
  },
};
</script>

<style scoped>
.status-action-row {
  align-items: center;
  border-top: 1px solid #edf2f3;
  display: flex;
  justify-content: space-between;
  margin: 6px 18px 0;
  padding: 18px 0 4px;
}

.status-action-row .btn-large {
  min-width: 138px;
}

@media only screen and (max-width: 600px) {
  .status-action-row {
    align-items: stretch;
    flex-direction: column;
    gap: 10px;
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
